import axios from "axios";
import store from "../store/index";
import { API_BASE_URL } from "../utils/helper";

/** Action type constants for consistent strings when calling storeAction (e.g. 'login', 'txn-search') */
export const ACTION_TYPES = {
  LOGIN: "login",
  TRANSACTION_SEARCH: "txn-search",
  DOWNLOAD_DOCUMENT: "download-document"
};

export const serviceLevelMonitoringService = {
  recordData,
  calculateTimeTaken
};

function toDate(value) {
  if (value == null) return null;
  if (value instanceof Date) return value;
  if (typeof value === "number") return new Date(value);
  if (typeof value === "string") return new Date(value);
  return null;
}

function calculateTimeTaken(startTime, endTime) {
  const start = toDate(startTime);
  if (start == null) return 0;

  const end = toDate(endTime) || new Date();

  return Math.max(0, end.getTime() - start.getTime()) / 1000;
}

function roundSecondsToTwoDecimals(seconds) {
  return Math.round(Number(seconds) * 100) / 100;
}

async function recordData(monitoringData = {}) {
  const { requestStartTime, requestEndTime } = monitoringData;
  const timeTakenInSeconds = roundSecondsToTwoDecimals(
    calculateTimeTaken(requestStartTime, requestEndTime)
  );

  const body = {
    action: monitoringData.actionType,
    fiNumber: monitoringData.fiNumber,
    loggedInUserId: monitoringData.loggedInUserId,
    requestParams: monitoringData.requestParams,
    requestStartTime,
    requestEndTime,
    responseTimeInSecs: timeTakenInSeconds
  };

  try {
    await axios.post(API_BASE_URL() + `/service-level-monitoring`, body, {
      headers: { "Content-Type": "application/json" },
    });
    return true;
  } catch (err) {
    console.warn("[serviceLevelMonitoring] record failed:", err?.message || err);
    return false;
  }
}
